import React from 'react';
import { FadeIn } from './FadeIn';
import { WheatOffIcon, MilkOffIcon, CandyOffIcon, CookieIcon } from 'lucide-react';
export function Villains() {
  const villains = [{
    icon: <WheatOffIcon className="w-6 h-6 text-[#7A2818]" data-id="element-575" />,
    title: 'Gluten',
    desc: 'Libera zonulina y abre las paredes intestinales. Hasta el 75% reduce el dolor al eliminarlo.'
  }, {
    icon: <MilkOffIcon className="w-6 h-6 text-[#7A2818]" data-id="element-576" />,
    title: 'Lácteos A1',
    desc: 'La caseína A1 se convierte en BCM-7, disparador de histamina y alterador estrogénico.'
  }, {
    icon: <CandyOffIcon className="w-6 h-6 text-[#7A2818]" data-id="element-577" />,
    title: 'Azúcares Refinados',
    desc: 'Picos de insulina que activan la aromatasa. Más azúcar = más estrógeno = más endometriosis.'
  }, {
    icon: <CookieIcon className="w-6 h-6 text-[#7A2818]" data-id="element-578" />,
    title: 'Omega-6 Refinados',
    desc: 'Aceites de girasol, maíz y soja disparan prostaglandinas: las responsables de los cólicos.'
  }];
  return <section className="py-12 md:py-24 bg-[#1b2f28]" data-id="element-579">
      <FadeIn className="container mx-auto px-5 max-w-[1200px]" data-id="element-580">
        <div className="max-w-3xl mb-10 md:mb-16" data-id="element-581">
          <span className="text-peach text-xs font-bold tracking-[0.2em] uppercase mb-3 md:mb-4 block" data-id="element-582">
            Capítulo 2 · La lista negra
          </span>
          <h2 className="font-serif text-3xl md:text-5xl lg:text-6xl text-cream mb-4 md:mb-6" data-id="element-583">
            Los <span className="italic text-peach" data-id="element-584">4 villanos</span> de tu
            vientre
          </h2>
          <p className="text-sand/90 text-lg md:text-xl leading-relaxed max-w-2xl" data-id="element-585">
            No son restricciones arbitrarias. Son eliminaciones estratégicas
            basadas en la biología de la endometriosis. En 21 días, tus
            receptores hormonales se limpian y tu barrera intestinal empieza a
            repararse.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-586">
          {villains.map((v, idx) => <div key={idx} className="bg-[#233831] border-l-[3px] border-[#7A2818] rounded-xl p-6 md:p-10 shadow-lg" data-id="element-587">
              <div className="flex items-start gap-4 md:gap-6 mb-5 md:mb-6" data-id="element-588">
                <div className="bg-[#7A2818]/10 p-4 rounded-xl shrink-0" data-id="element-589">
                  {v.icon}
                </div>
                <div data-id="element-590">
                  <div className="text-[#7A2818] text-[10px] font-bold tracking-widest uppercase mb-1" data-id="element-591">
                    Evitar
                  </div>
                  <h3 className="font-serif text-3xl text-cream" data-id="element-592">{v.title}</h3>
                </div>
              </div>
              <p className="text-sand/80 leading-relaxed text-lg" data-id="element-593">{v.desc}</p>
            </div>)}
        </div>
      </FadeIn>
    </section>;
}